"use client";

import { Markdown as Md } from "markdown-to-jsx/react";

type Props = {
  children: string;
  className?: string;
};

export function Markdown({ children, className = "" }: Props) {
  const content = typeof children === "string" ? children : "";
  return (
    <div className={`prose dark:prose-invert ${className}`}>
      <Md>{content}</Md>
    </div>
  );
}
